/* eslint react/prop-types: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

function querystring(n, url = window.location.href) {
  const name = n.replace(/[[]]/g, '\\$&');

  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`, 'i');
  const results = regex.exec(url);

  if (!results) { return null; }
  if (!results[2]) { return ''; }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const RouteUnauthenticated = ({ component: C, props: cProps, ...rest }) => {
  const redirect = querystring('redirect');
  return (
    <Route
      {...rest}
      render={props => (
        cProps.userToken === null
          ? <C {...props} {...cProps} />
          : <Redirect
            to={redirect || '/agreements'}
          />
      )}
    />
  );
};

RouteUnauthenticated.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.node,
  ]).isRequired,
  userToken: PropTypes.string,
};

RouteUnauthenticated.defaultProps = {
  userToken: null,
};

export default RouteUnauthenticated;



// WEBPACK FOOTER //
// ./src/components/RouteUnauthenticated.jsx